mutation Inertia_ReorderDocuments($orderId: ID!, $documentIds: [ID!]!) {
  reorderDocuments(input: { orderId: $orderId, documentIds: $documentIds }) {
    success
    errors
  }
}